export class NewSpaceData {
    public adminName: string = '';
    public adminEmail: string = '';
    public adminPassword: string = '';
    public spaceName: string = '';
    public spacePin: string = '';

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
